import { useMemo } from 'react';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

interface PreviewLineItemSequenceProps {
  itemValue?: string;
}

export const generatePreviewText = (total: number, numLineItems: number, itemValue?: string) => {
  const startItemNumber = total + 1;
  const endItemNumber = total + numLineItems;
  if (!itemValue || itemValue.trim().length === 0) {
    return '';
  } else if (numLineItems <= 3) {
    // For 2-3 items
    const itemNumbers = [];
    for (let i = startItemNumber; i <= endItemNumber; i++) {
      itemNumbers.push(`${itemValue} ${i}`);
    }
    return itemNumbers.join(', ');
  } else {
    //  More than 3
    return `${itemValue} ${startItemNumber}, ${itemValue} ${
      startItemNumber + 1
    }, ... ${itemValue} ${endItemNumber}`;
  }
};

const PreviewLineItemSequence = ({ itemValue }: PreviewLineItemSequenceProps) => {
  const { numLineItems } = useContextSelector(InvoiceContext, (context) => context);
  const invoiceLineItems = useContextSelector(
    InvoiceContext,
    (context) => context.invoiceLineItems
  );
  const total = useMemo(() => invoiceLineItems?.length || 0, [invoiceLineItems]);

  const previewText = generatePreviewText(total, numLineItems, itemValue);
  return previewText ? (
    <div className="text-[#dcab4c] text-[11px] font-medium mt-1">Preview: {previewText}</div>
  ) : null;
};

export default PreviewLineItemSequence;
